/**
 * Friendly names for province/state codes stored in `CustomerAddress.province`
 * (mapped from the Retail CRM `addressState` field, e.g. "IE_WW").
 *
 * Keyed by ISO country code, then by the full province code.
 * Generated from the province mapping source — do not edit by hand.
 */
export const PROVINCE_NAMES: Readonly<Record<string, Record<string, string>>> = {
  BE: {
    BE_BRU: 'Brussels Hoofdstedelijk Gewest',
    BE_VLG: 'Vlaanderen',
    BE_WAL: 'Wallonië',
  },
  DE: {
    DE_BB: 'Brandenburg',
    DE_BE: 'Berlin',
    DE_BW: 'Baden-Württemberg',
    DE_BY: 'Bayern',
    DE_HB: 'Bremen',
    DE_HE: 'Hessen',
    DE_HH: 'Hamburg',
    DE_MV: 'Mecklenburg-Vorpommern',
    DE_NI: 'Niedersachsen',
    DE_NW: 'Nordrhein-Westfalen',
    DE_RP: 'Rheinland-Pfalz',
    DE_SH: 'Schleswig-Holstein',
    DE_SL: 'Saarland',
    DE_SN: 'Sachsen',
    DE_ST: 'Sachsen-Anhalt',
    DE_TH: 'Thüringen',
  },
  ES: {
    ES_A: 'Alicante-Alacant',
    ES_AB: 'Albacete',
    ES_AL: 'Almería',
    ES_AV: 'Ávila',
    ES_B: 'Barcelona',
    ES_BA: 'Badajoz',
    ES_BI: 'Bizkaia',
    ES_BU: 'Burgos',
    ES_C: 'A Coruña',
    ES_CA: 'Cádiz',
    ES_CC: 'Cáceres',
    ES_CE: 'Ceuta',
    ES_CO: 'Córdoba',
    ES_CR: 'Ciudad Real',
    ES_CS: 'Castellón-Castelló',
    ES_CU: 'Cuenca',
    ES_GC: 'Las Palmas',
    ES_GI: 'Girona',
    ES_GR: 'Granada',
    ES_GU: 'Guadalajara',
    ES_H: 'Huelva',
    ES_HU: 'Huesca',
    ES_J: 'Jaén',
    ES_L: 'Lleida',
    ES_LE: 'León',
    ES_LO: 'La Rioja',
    ES_LU: 'Lugo',
    ES_M: 'Madrid',
    ES_MA: 'Málaga',
    ES_ML: 'Melilla',
    ES_MU: 'Murcia',
    ES_NA: 'Navarra',
    ES_O: 'Asturias',
    ES_OR: 'Ourense',
    ES_P: 'Palencia',
    ES_PM: 'Illes Balears',
    ES_PO: 'Pontevedra',
    ES_S: 'Cantabria',
    ES_SA: 'Salamanca',
    ES_SE: 'Sevilla',
    ES_SG: 'Segovia',
    ES_SO: 'Soria',
    ES_SS: 'Gipuzkoa',
    ES_T: 'Tarragona',
    ES_TE: 'Teruel',
    ES_TF: 'Santa Cruz de Tenerife',
    ES_TO: 'Toledo',
    ES_V: 'Valencia-València',
    ES_VA: 'Valladolid',
    ES_VI: 'Araba-Álava',
    ES_Z: 'Zaragoza',
    ES_ZA: 'Zamora',
  },
  FR: {
    FR_20R: 'Corse',
    FR_971: 'Guadeloupe',
    FR_972: 'Martinique',
    FR_973: 'Guyane',
    FR_974: 'La Réunion',
    FR_976: 'Mayotte',
    FR_ARA: 'Auvergne-Rhône-Alpes',
    FR_BFC: 'Bourgogne-Franche-Comté',
    FR_BRE: 'Bretagne',
    FR_CVL: 'Centre-Val de Loire',
    FR_GES: 'Grand-Est',
    FR_HDF: 'Hauts-de-France',
    FR_IDF: 'Île-de-France',
    FR_NAQ: 'Nouvelle-Aquitaine',
    FR_NOR: 'Normandie',
    FR_OCC: 'Occitanie',
    FR_PAC: 'Provence-Alpes-Côte-d’Azur',
    FR_PDL: 'Pays-de-la-Loire',
  },
  GB: {
    GB_ENG: 'England',
    GB_NIR: 'Northern Ireland',
    GB_SCT: 'Scotland',
    GB_WLS: 'Wales',
  },
  IE: {
    IE_CE: 'Clare',
    IE_CN: 'Cavan',
    IE_CO: 'Cork',
    IE_CW: 'Carlow',
    IE_D: 'Dublin',
    IE_DL: 'Donegal',
    IE_G: 'Galway',
    IE_KE: 'Kildare',
    IE_KK: 'Kilkenny',
    IE_KY: 'Kerry',
    IE_LD: 'Longford',
    IE_LH: 'Louth',
    IE_LK: 'Limerick',
    IE_LM: 'Leitrim',
    IE_LS: 'Laois',
    IE_MH: 'Meath',
    IE_MN: 'Monaghan',
    IE_MO: 'Mayo',
    IE_OY: 'Offaly',
    IE_RN: 'Roscommon',
    IE_SO: 'Sligo',
    IE_TA: 'Tipperary',
    IE_WD: 'Waterford',
    IE_WH: 'Westmeath',
    IE_WW: 'Wicklow',
    IE_WX: 'Wexford',
  },
  LU: {
    LU_CA: 'Capellen',
    LU_CL: 'Clerf',
    LU_DI: 'Diekirch',
    LU_EC: 'Echternach',
    LU_ES: 'Esch an der Alzette',
    LU_GR: 'Grevenmacher',
    LU_LU: 'Luxemburg',
    LU_ME: 'Mersch',
    LU_RD: 'Redingen',
    LU_RM: 'Remich',
    LU_VD: 'Vianden',
    LU_WI: 'Wiltz',
  },
  NL: {
    NL_DR: 'Drenthe',
    NL_FL: 'Flevoland',
    NL_FR: 'Fryslân',
    NL_GE: 'Gelderland',
    NL_GR: 'Groningen',
    NL_LI: 'Limburg',
    NL_NB: 'Noord-Brabant',
    NL_NH: 'Noord-Holland',
    NL_OV: 'Overijssel',
    NL_UT: 'Utrecht',
    NL_ZE: 'Zeeland',
    NL_ZH: 'Zuid-Holland',
  },
};
